import dayjs from 'dayjs'
import { getIn, useFormikContext } from 'formik'
import { useMemo } from 'react'
import ReactDatePicker from 'react-datepicker'
import AutoCompleteField, { VField } from '../../components/Fields'
import { API_URL, USER_ROLES_CLIENTI } from '../../constants'
import { useIsCliente } from '../../utils/utils'

type FormUtenteValues = {
  full_name?: string
  email?: string
  role?: string
  nome_holding?: string
  clienti: number[]
  expiration_date?: Date | string | null
}

export default function FormUtenteCliente() {
  const { values, setFieldValue, errors, touched } = useFormikContext<FormUtenteValues>()
  const isCliente = useIsCliente()

  const excludeClientiValue = useMemo(() => {
    if (getIn(values, 'clienti')) {
      return getIn(values, 'clienti').join(',')
    }
    return ''
  }, [values])

  return (
    <div className="row">
      <div className="col-6">
        <VField name="full_name" label="Nome e Cognome" type="text" required />
      </div>
      <div className="col-6">
        <VField name="email" label="Email" type="email" required />
      </div>
      <div className="col-6">
        <VField name="role" label="Ruolo" as="select" required>
          <option value="">Seleziona un ruolo</option>
          {Object.values(USER_ROLES_CLIENTI).map((role) => (
            <option key={role.value} value={role.value}>
              {role.label}
            </option>
          ))}
        </VField>
      </div>
      <div className="col-6" />

      <div className="col-md-6">
        <VField name="nome_holding" label="Nome Holding" type="text" disabled={isCliente} />
      </div>

      <div className="col-md-6">
        <AutoCompleteField
          name="clienti"
          url={`${API_URL}/bilance/cliente/options`}
          onChange={(value) => {
            setFieldValue('clienti', value ? value.map((v: any) => v.value) : [])
          }}
          label="Aziende"
          required
          keyQuery="options-cliente"
          value={values.clienti}
          isMulti
          params={{ exclude_ids: excludeClientiValue }}
          isDisabled={isCliente}
        />
      </div>
      <div className="col-6">
        <div className="form-group mb-3">
          <label className="label-m label-field">SCADENZA</label>
          <div className="text-danger error-field">
            {getIn(errors, 'expiration_date') && getIn(touched, 'expiration_date') && getIn(errors, 'expiration_date')}
          </div>
          {!isCliente && <div className="text-secondary error-field">{`Non compilare per calcolo automatico`}</div>}
          <ReactDatePicker
            isClearable
            placeholderText="Seleziona data di scadenza"
            className="form-control me-2 text-secondary"
            dateFormat={'dd/MM/yyyy'}
            onChange={(date) => {
              if (date) {
                setFieldValue('expiration_date', dayjs(date).format('YYYY-MM-DD'))
              } else {
                setFieldValue('expiration_date', null)
              }
            }}
            selected={values.expiration_date ? dayjs(values.expiration_date).toDate() : null}
            disabled={isCliente}
            minDate={dayjs().toDate()}
          />
        </div>
      </div>
    </div>
  )
}
